// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"492e6b75","578":"4c46475d","821":"a4afff1c","857":"c9fa6b4d","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};